import { useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PersonIcon from "@mui/icons-material/Person";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkIcon from "@mui/icons-material/Link";
import SendIcon from "@mui/icons-material/Send";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  createAndAddUserToGroup,
  createAndAddUserToUserList,
  generateSetupToken,
  getGroupMembers360Info,
  getUsersEval,
  getUsersNotInGroup,
  getUsersNotInUserList,
  sendLaunchEmails,
  sendReminderEmails,
  send360Report,
  update360AssessmentCompleted,
  updateGroup,
  updateGroup360,
  updateGroupDeadline,
  updateRevieweeDeadline,
  updateUserList,
  FRONT_URL,
} from "../axios/axiosFunctions";
import { DataGrid } from "@mui/x-data-grid";
import { columnsGroups360 } from "../utils/groups360Table";
import { columnsUsersList } from "../utils/userEvalTable";
import { useParams } from "react-router-dom";
import GroupActionButoons from "./GroupActionButoons";
import TeamCard from "./TeamCard";
import CsvUploadCombined360 from "./CsvUploadCombined360";
import ViewResponsesDialog from "./ViewResponsesDialog";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const defaultUser = {
  firstName: "",
  lastName: "",
  email: "",
  type: "",
};

const TeamsCards360 = ({ group, callGroups, onEdit, onDelete }) => {
  const { slugAssessment } = useParams();
  const fileInputRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [rows, setRows] = useState([{ id: 1 }]);
  const [rowsUsers, setRowsUsers] = useState([{ id: 1 }]);
  const [showDropdown, setShowDropdown] = useState(true);
  const [showDropdown2, setShowDropdown2] = useState(true);
  const [users, setUsers] = useState([]);
  const [users2, setUsers2] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersList2, setUsersList2] = useState([]);
  const [selectOpt, setSelectOpt] = useState([]);
  const [selectOpt2, setSelectOpt2] = useState([]);
  const [error, setError] = useState("");
  const [showError, setShowError] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [msg2, setMsg2] = useState("");
  const [showMsg2, setShowMsg2] = useState(false);
  const [msgSeverity2, setMsgSeverity2] = useState("success");
  const [msg3, setMsg3] = useState("");
  const [showMsg3, setShowMsg3] = useState(false);
  const [msgSeverity3, setMsgSeverity3] = useState("success");
  const [loading, setLoading] = useState(true);
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [openDialogCreate2, setOpenDialogCreate2] = useState(false);
  const [userForm, setUserForm] = useState(defaultUser);
  const { firstName, lastName, email, type } = userForm;
  const [dialogUsers, setDialogUsers] = useState(false);
  const [currentOwner, setCurrentOwner] = useState();
  const [ownerInfo, setOwnerInfo] = useState();
  const [alertReport, setAlertReport] = useState(false);
  const [openCsvCombinedDialog, setOpenCsvCombinedDialog] = useState(false);
  const [setupLink, setSetupLink] = useState("");
  const [linkCopied, setLinkCopied] = useState(false);
  const [sendEmailsDialogOpen, setSendEmailsDialogOpen] = useState(false);
  const [sendingEmails, setSendingEmails] = useState(false);
  const [sendEmailsAlert, setSendEmailsAlert] = useState(false);
  const [sendEmailsAlertMsg, setSendEmailsAlertMsg] = useState("");
  const [sendEmailsAlertSeverity, setSendEmailsAlertSeverity] = useState("success");
  const [sendRemindersDialogOpen, setSendRemindersDialogOpen] = useState(false);
  const [sendingReminders, setSendingReminders] = useState(false);
  const [sendRemindersAlert, setSendRemindersAlert] = useState(false);
  const [sendRemindersAlertMsg, setSendRemindersAlertMsg] = useState("");
  const [sendRemindersAlertSeverity, setSendRemindersAlertSeverity] = useState("success");
  const [groupDeadline, setGroupDeadline] = useState(
    group.deadline ? new Date(group.deadline).toISOString().split("T")[0] : ""
  );
  const [revieweeDeadline, setRevieweeDeadline] = useState("");
  const [generateReportDialogOpen, setGenerateReportDialogOpen] = useState(false);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [openConfirmSend360, setOpenConfirmSend360] = useState(false);
  const [sendingReport360, setSendingReport360] = useState(false);
  const [openSelfAssessment, setOpenSelfAssessment] = useState(false);
  const [reportSent360, setReportSent360] = useState(false);
  const [typeDialogOpen, setTypeDialogOpen] = useState(false);
  const [pendingReviewer, setPendingReviewer] = useState(null);
  const [pendingReviewerType, setPendingReviewerType] = useState("");

  const handleCopySetupLink = async () => {
    let token = group.setupToken;
    if (!token) {
      const res = await generateSetupToken(group._id);
      if (res.setupToken) {
        token = res.setupToken;
      } else {
        return;
      }
    }
    const link = `${FRONT_URL}setup/${token}`;
    setSetupLink(link);
    navigator.clipboard.writeText(link);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 3000);
  };

  const handleSendLaunchEmails = async () => {
    setSendingEmails(true);
    try {
      const res = await sendLaunchEmails(group._id, {
        slug: slugAssessment,
        frontUrl: FRONT_URL,
      });
      if (res.error) {
        setSendEmailsAlertSeverity("error");
        setSendEmailsAlertMsg(res.msg || "Error sending emails. Please try again.");
      } else {
        setSendEmailsAlertSeverity("success");
        setSendEmailsAlertMsg(
          res.msg || "Emails sent successfully to all users in this group."
        );
      }
    } catch (err) {
      setSendEmailsAlertSeverity("error");
      setSendEmailsAlertMsg("Error sending emails. Please try again.");
    }
    setSendingEmails(false);
    setSendEmailsAlert(true);
    setSendEmailsDialogOpen(false);
  };

  const handleSendReminderEmails = async () => {
    setSendingReminders(true);
    try {
      const res = await sendReminderEmails(group._id, {
        slug: slugAssessment,
        frontUrl: FRONT_URL,
      });
      if (res.error) {
        setSendRemindersAlertSeverity("error");
        setSendRemindersAlertMsg(res.msg || "Error sending reminders. Please try again.");
      } else {
        setSendRemindersAlertSeverity("success");
        setSendRemindersAlertMsg(
          `${res.msg || "Reminders sent."}${res.remindersSent !== undefined ? ` (${res.remindersSent} sent, ${res.skippedCompleted} already completed)` : ""}`
        );
      }
    } catch (err) {
      setSendRemindersAlertSeverity("error");
      setSendRemindersAlertMsg("Error sending reminders. Please try again.");
    }
    setSendingReminders(false);
    setSendRemindersAlert(true);
    setSendRemindersDialogOpen(false);
  };

  const handleGroupDeadlineChange = async (e) => {
    const value = e.target.value;
    setGroupDeadline(value);
    await updateGroupDeadline(group._id, { deadline: value || null });
  };

  const handleRevieweeDeadlineChange = async (e) => {
    const value = e.target.value;
    setRevieweeDeadline(value);
    await updateRevieweeDeadline(currentOwner, group._id, { deadline: value || null });
  };

  useEffect(() => {
    updateTable();
  }, [group]);

  const updateTable = () => {
    setLoading(true);
    callMembersInfo();
    callUsersToAdd();
  };

  const callMembersInfo = async () => {
    const info = await getGroupMembers360Info(group._id, slugAssessment);
    const tempRows = info.data.map((u) => ({
      id: u._id,
      firstName: u.firstName || "",
      lastName: u.lastName || "",
      email: u.email,
      type: u.rol,
      status: u.status,
      userId: u._id,
      groupId: group._id,
    }));
    setRows(tempRows);
    setLoading(false);
  };

  const callUsersToAdd = async () => {
    const res = await getUsersNotInGroup(group._id);
    if (res) {
      setUsers(res.users);
      mapOptions(res.users);
    }
  };

  const callUsersListToAdd = async (ownerId, groupId) => {
    const res = await getUsersNotInUserList(groupId, ownerId);
    if (res) {
      setUsers2(res.users);
      mapOptions2(res.users);
    }
  };

  const callUsersEval = async (userId, groupId) => {
    if (!userId || !groupId) {
      return;
    }
    const info = await getUsersEval(userId, groupId);
    if (!info || !info.userList) {
      return;
    }
    const tempRows = info.userList.map((u) => ({
      id: u._id,
      firstName: u.firstName || "",
      lastName: u.lastName || "",
      email: u.email,
      type: u.rol,
      status: u.status,
      userId: u._id,
      groupId: group._id,
    }));
    setRowsUsers(tempRows);
    // Load individual reviewee deadline
    setRevieweeDeadline(
      info.revieweeDeadline
        ? new Date(info.revieweeDeadline).toISOString().split("T")[0]
        : ""
    );
  };

  const mapOptions = (usersArray) => {
    if (!usersArray || usersArray.length === 0) {
      setSelectOpt([]);
      return;
    }

    const tempOpt = usersArray.map((u, i) => ({
      label: `${u.firstName}${u.lastName ? ` ${u.lastName}` : ""}`,
      index: i,
    }));
    setSelectOpt(tempOpt);
  };

  const mapOptions2 = (usersArray) => {
    if (!usersArray || usersArray.length === 0) {
      setSelectOpt2([]);
      return;
    }

    const tempOpt = usersArray.map((u, i) => ({
      label: `${u.firstName}${u.lastName ? ` ${u.lastName}` : ""}`,
      index: i,
    }));
    setSelectOpt2(tempOpt);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDialogUsersClose = () => {
    setDialogUsers(false);
  };

  const handleUploadFile = async (e) => {
    /* const { length } = e.target.files;
        if (length !== 0) {

            const formData = new FormData();
            formData.append("file", e.target.files[0]);
            formData.append("groupId", group._id);
            
            const resp = await uploadCsv(formData);     

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            if(resp){
                handleDialogClose();
                callGroups();
            }
        } */
  };

  const showMemberSelect = () => {
    setShowDropdown(!showDropdown);
  };

  const showUserSelect = () => {
    setShowDropdown2(!showDropdown2);
  };

  const handleChange = (e, newValue) => {
    if (!newValue) return;
    const { index } = newValue;
    const newUsersList = [...usersList];
    const selectedElemet = users[index];

    const newUsersToAdd = [...users.slice(0, index), ...users.slice(index + 1)];

    newUsersList.push(selectedElemet);
    setUsers(newUsersToAdd);
    mapOptions(newUsersToAdd);
    setUsersList(newUsersList);
  };

  const [usersList2Types, setUsersList2Types] = useState({});

  const handleChange2 = (e, newValue) => {
    if (!newValue) return;
    const { index } = newValue;
    const selectedElemet = users2[index];
    setPendingReviewer(selectedElemet);
    setPendingReviewerType("");
    setTypeDialogOpen(true);
  };

  const handleConfirmReviewerType = () => {
    if (!pendingReviewer || !["manager", "direct", "peer", "otherColleague"].includes(pendingReviewerType)) return;
    const user = pendingReviewer;
    // Find and remove from users2 by _id (not index, which could be stale)
    const newUsersToAdd = users2.filter((u) => u._id !== user._id);
    setUsers2(newUsersToAdd);
    mapOptions2(newUsersToAdd);
    setUsersList2((prev) => [...prev, user]);
    setUsersList2Types((prev) => ({ ...prev, [user._id]: pendingReviewerType }));
    setTypeDialogOpen(false);
    setPendingReviewer(null);
    setPendingReviewerType("");
  };

  const handleCancelReviewerType = () => {
    setTypeDialogOpen(false);
    setPendingReviewer(null);
    setPendingReviewerType("");
  };

  const handleUsersList2TypeChange = (userId, newType) => {
    setUsersList2Types((prev) => ({ ...prev, [userId]: newType }));
  };

  const submitNewMembers = async () => {
    setLoading(true);
    if (usersList.length === 0) {
      return;
    }

    const usersToAdd = usersList.map((u) => u._id);
    const currentUsers = rows.map((u) => u.userId);

    const data = {
      members: usersToAdd.concat(currentUsers),
    };

    const res = await updateGroup360(group._id, slugAssessment, data);
    if (!res) {
      setError("Error while saving please try later");
      setShowError(true);
      setAlertSeverity("error");
      setTimeout(() => {
        setShowError(false);
      }, 4000);
      return;
    }
    callMembersInfo();
    callUsersToAdd();
    cancelAddNewMembers();
    callGroups();
  };
  const submitNewMembers2 = async () => {
    if (usersList2.length === 0) {
      return;
    }

    // Validate all pending reviewers have a type assigned
    const missingType = usersList2.some(
      (u) => !["manager", "direct", "peer", "otherColleague"].includes(usersList2Types[u._id])
    );
    if (missingType) {
      setError("Please assign a Type to all reviewers before adding.");
      setShowError(true);
      setAlertSeverity("error");
      setTimeout(() => {
        setShowError(false);
      }, 4000);
      return;
    }

    const usersToAdd = usersList2.map((u) => u._id);
    const currentUsers = rowsUsers.map((u) => u.userId);

    const usersWithTypes = usersList2.map((u) => ({
      userId: u._id,
      type: usersList2Types[u._id],
    }));

    const data = {
      users: usersToAdd.concat(currentUsers),
      usersWithTypes,
    };

    const res = await updateUserList(
      ownerInfo.groupId,
      ownerInfo.ownerId,
      data,
    );
    if (!res) {
      setError("Error while saving please try later");
      setShowError(true);
      setAlertSeverity("error");
      setTimeout(() => {
        setShowError(false);
      }, 4000);
      return;
    }

    callUsersListToAdd(ownerInfo.ownerId, ownerInfo.groupId);
    cancelAddNewMembers2();
    callUsersEval(ownerInfo.ownerId, ownerInfo.groupId);
  };

  const cancelAddNewMembers = () => {
    setUsersList([]);
    callUsersToAdd();
  };

  const cancelAddNewMembers2 = () => {
    setUsersList2([]);
    setUsersList2Types({});
  };

  const handleChangeCreate = (e) => {
    const { name, value } = e.target;
    setUserForm({ ...userForm, [name]: value });
  };

  const validateCreateUser = () => {
    return firstName !== "" && lastName !== "" && email !== "";
  };

  const validateCreateUser2 = () => {
    return (
      firstName !== "" && lastName !== "" && email !== "" && type !== ""
    );
  };

  const handleCloseDialogCreate = () => {
    setOpenDialogCreate(false);
  };

  const handleCloseDialogCreate2 = () => {
    setOpenDialogCreate2(false);
  };

  const handleCreateUser = async () => {
    const isValid = validateCreateUser();
    if (!isValid) {
      setMsg2("Complete all fields");
      setShowMsg2(true);
      setMsgSeverity2("error");
      setTimeout(() => {
        setShowMsg2(false);
      }, 2000);
      return;
    }
    const data = {
      ...userForm,
      slug: slugAssessment,
    };

    const res = await createAndAddUserToGroup(group._id, data);
    if (!res.user) {
      setMsg2(res.msg);
      setShowMsg2(true);
      setMsgSeverity2("error");
      setTimeout(() => {
        setShowMsg2(false);
      }, 2000);
      return;
    }
    setMsg2("User created correctly");
    setShowMsg2(true);
    setMsgSeverity2("success");
    setTimeout(() => {
      setShowMsg2(false);
      updateTable();
      callGroups();
      setUserForm(defaultUser);
      handleCloseDialogCreate();
    }, 2000);
    return;
  };

  const handleCreateUser2 = async () => {
    const isValid = validateCreateUser2();
    if (!isValid) {
      setMsg3("Complete all fields");
      setShowMsg3(true);
      setMsgSeverity3("error");
      setTimeout(() => {
        setShowMsg3(false);
      }, 2000);
      return;
      return;
    }

    const res = await createAndAddUserToUserList(
      group._id,
      currentOwner,
      userForm,
    );
    if (!res.user) {
      setMsg3(res.msg);
      setShowMsg3(true);
      setMsgSeverity3("error");
      setTimeout(() => {
        setShowMsg3(false);
      }, 2000);
      return;
    }
    setMsg3("User created correctly");
    setShowMsg3(true);
    setMsgSeverity3("success");
    setTimeout(() => {
      setShowMsg3(false);
      callUsersEval(ownerInfo.ownerId, ownerInfo.groupId);
      setUserForm(defaultUser);
      handleCloseDialogCreate2();
    }, 2000);
    return;
  };

  const handleCellClick = (e) => {
    const { row, colDef } = e;
    if (colDef.field === "lastName" || colDef.field === "firstName") {
      setUser(row.userId, row.groupId);
    }
  };

  const setUser = (userId, groupId) => {
    callUsersEval(userId, groupId);
    setCurrentOwner(userId);
    setOwnerInfo({
      ownerId: userId,
      groupId: groupId,
    });
    callUsersListToAdd(userId, groupId);
    setDialogUsers(true);
  };

  const handleGenerateReport360 = async () => {
    setGeneratingReport(true);
    const data = {
      groupId: group._id,
      slug: slugAssessment,
      completed: true,
      owner: currentOwner,
      frontUrl: FRONT_URL,
    };
    const res = await update360AssessmentCompleted(data);
    setGeneratingReport(false);
    setGenerateReportDialogOpen(false);
    if (res) {
      setAlertReport(true);
      callGroups();
      setTimeout(() => {
        setAlertReport(false);
      }, 3000);
    }
  };

  const handlePreviewReport360 = () => {
    window.open(`/${slugAssessment}/${group._id}/${currentOwner}/report`, '_blank');
  };

  const handleSendReport360 = async () => {
    setSendingReport360(true);
    setOpenConfirmSend360(false);
    const frontUrl = process.env.REACT_APP_FRONT_URL || "https://assessments.know2grow.com/";
    const res = await send360Report(group._id, { frontUrl, slug: slugAssessment, owner: currentOwner });
    setSendingReport360(false);
    if (res.error) {
      setAlertReport(true);
      setTimeout(() => { setAlertReport(false); }, 4000);
      return;
    }
    setReportSent360(true);
    setAlertReport(true);
    callGroups();
    setTimeout(() => { setAlertReport(false); }, 4000);
  };

  return (
    <>
      <TeamCard
        group={group}
        loading={loading}
        onClick={handleOpenDialog}
        onEdit={onEdit}
        onDelete={onDelete}
      />
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
            <Typography variant="h5" sx={{ textAlign: "center" }}>
              {group.name}
            </Typography>
            <Button
              variant="outlined"
              startIcon={linkCopied ? <ContentCopyIcon /> : <LinkIcon />}
              onClick={handleCopySetupLink}
              color={linkCopied ? "success" : "primary"}
              size="small"
            >
              {linkCopied ? "Link Copied!" : "Copy Setup Link"}
            </Button>
          </Box>
          {setupLink && (
            <Box sx={{ mt: 1, mb: 1, p: 1, bgcolor: "grey.100", borderRadius: 1 }}>
              <Typography variant="caption" sx={{ wordBreak: "break-all" }}>
                {setupLink}
              </Typography>
            </Box>
          )}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            gap={2}
            sx={{ mt: 1, mb: 1 }}
          >
            <Typography variant="subtitle1" fontWeight={500}>
              Group Deadline:
            </Typography>
            <TextField
              type="date"
              size="small"
              value={groupDeadline}
              onChange={handleGroupDeadlineChange}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 200 }}
            />
          </Box>
          <Divider sx={{ margin: "10px 0px" }} />
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            REVIEWEE LIST
          </Typography>
          <DataGrid
            onCellClick={handleCellClick}
            columns={columnsGroups360}
            rows={rows.map((row) => ({
              ...row,
              updateTable,
              setUser,
              callGroups,
            }))}
          />
          <Dialog
            open={dialogUsers}
            onClose={handleDialogUsersClose}
            maxWidth="lg"
            fullWidth
          >
            <DialogContent>
              <Typography>REVIEWERS LIST</Typography>
              <Box
                display="flex"
                alignItems="center"
                gap={2}
                sx={{ mt: 1, mb: 1 }}
              >
                <Typography variant="subtitle2" fontWeight={500}>
                  Individual Deadline (overrides group):
                </Typography>
                <TextField
                  type="date"
                  size="small"
                  value={revieweeDeadline}
                  onChange={handleRevieweeDeadlineChange}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: 200 }}
                />
              </Box>
              <Divider sx={{ margin: "10px 0px" }} />
              {rowsUsers.some((r) => !["manager","direct","peer","otherColleague"].includes(r.type)) && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                  One or more reviewers do not have a Type assigned. Please click the Edit button (pencil icon) to assign a Type (Manager, Direct Report, Peer, or Other Colleague) to each reviewer.
                </Alert>
              )}
              <DataGrid
                columns={columnsUsersList}
                rows={rowsUsers.map((row) => ({
                  ...row,
                  callUsersEval,
                  callUsersListToAdd,
                  owner: currentOwner,
                }))}
              />
              {alertReport && (
                <Alert sx={{ marginTop: "20px" }} severity={"success"}>
                  {reportSent360 ? "Report sent and email delivered to reviewee." : "Report generated successfully."}
                </Alert>
              )}
              <Box
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
              >
                <Button onClick={() => setOpenSelfAssessment(true)} variant="outlined" color="success">
                  VIEW SELF-ASSESSMENT
                </Button>
                <Button onClick={handlePreviewReport360} variant="outlined">
                  PREVIEW REPORT
                </Button>
                {reportSent360 ? (
                  <Button disabled variant="contained" color="success">
                    REPORT SENT ✓
                  </Button>
                ) : (
                  <Button
                    onClick={() => setOpenConfirmSend360(true)}
                    variant="contained"
                    color="primary"
                    disabled={sendingReport360}
                  >
                    {sendingReport360 ? <CircularProgress size={24} color="inherit" /> : "SEND REPORT"}
                  </Button>
                )}
              </Box>
              <Box
                display={"flex"}
                justifyContent={"space-evenly"}
                sx={{ marginTop: "20px" }}
              >
                {!showDropdown2 && (
                  <Button onClick={showUserSelect} variant="contained">
                    ADD REVIEWERS
                  </Button>
                )}
              </Box>
              {showDropdown2 && (
                <>
                  <Box display="flex" gap={2} sx={{ mb: 2 }}>
                    <Button
                      onClick={() => setOpenDialogCreate2(true)}
                      startIcon={<AddCircleOutlineIcon />}
                      variant="contained"
                    >
                      Create Reviewer
                    </Button>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ alignSelf: "center" }}
                    >
                      Or use the unified CSV upload above to add both reviewees
                      and reviewers at once
                    </Typography>
                  </Box>
                  <Autocomplete
                    onChange={handleChange2}
                    options={selectOpt2}
                    renderInput={(params) => (
                      <TextField {...params} label="Search existing user" />
                    )}
                    sx={{ margin: "20px 0px" }}
                  />
                  <Dialog
                    open={openDialogCreate2}
                    onClose={handleCloseDialogCreate2}
                  >
                    <DialogContent>
                      <Typography variant="h5" color="primary">
                        CREATE REVIEWER
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid size={6}>
                          <Typography variant="subtitle1">
                            First Name
                          </Typography>
                          <TextField
                            onChange={handleChangeCreate}
                            value={firstName}
                            name="firstName"
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <Typography variant="subtitle1">Last Name</Typography>
                          <TextField
                            onChange={handleChangeCreate}
                            value={lastName}
                            name="lastName"
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <Typography variant="subtitle1">Email</Typography>
                          <TextField
                            onChange={handleChangeCreate}
                            value={email}
                            name="email"
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <Typography variant="subtitle1">Type</Typography>
                          <FormControl sx={{ width: "100%" }}>
                            <Select
                              onChange={handleChangeCreate}
                              value={type}
                              name="type"
                              fullWidth
                            >
                              <MenuItem value={"manager"}>Manager</MenuItem>
                              <MenuItem value={"direct"}>
                                Direct Report
                              </MenuItem>
                              <MenuItem value={"peer"}>
                                Peer
                              </MenuItem>
                              <MenuItem value={"otherColleague"}>
                                Other Colleague
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        {showMsg3 && (
                          <Grid size={12}>
                            <Alert
                              sx={{ marginTop: "20px" }}
                              severity={msgSeverity3}
                            >
                              {msg3}
                            </Alert>
                          </Grid>
                        )}
                        <Grid
                          size={12}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <Button
                            onClick={handleCreateUser2}
                            variant="contained"
                          >
                            CREATE
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleCloseDialogCreate2}
                            sx={{ marginLeft: "20px" }}
                          >
                            CANCEL
                          </Button>
                        </Grid>
                      </Grid>
                    </DialogContent>
                  </Dialog>
                </>
              )}
              {usersList2.length > 0 && (
                <>
                  <Typography
                    variant="subtitle1"
                    fontWeight={500}
                    color="secondary"
                    sx={{ marginTop: "20px" }}
                  >
                    REVIEWERS to Add
                  </Typography>
                  <List>
                    {usersList2.map((u, i) => (
                      <ListItem key={i} sx={{ gap: 2 }}>
                        <ListItemIcon>
                          <PersonIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${u.firstName}${u.lastName ? ` ${u.lastName}` : ""}`}
                        />
                        <FormControl size="small" sx={{ minWidth: 200 }}>
                          <Select
                            value={usersList2Types[u._id] || ""}
                            onChange={(e) => handleUsersList2TypeChange(u._id, e.target.value)}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>Select Type *</MenuItem>
                            <MenuItem value="manager">Manager</MenuItem>
                            <MenuItem value="direct">Direct Report</MenuItem>
                            <MenuItem value="peer">Peer</MenuItem>
                            <MenuItem value="otherColleague">Other Colleague</MenuItem>
                          </Select>
                        </FormControl>
                      </ListItem>
                    ))}
                  </List>
                  {showError && (
                    <Alert sx={{ marginTop: "20px" }} severity={alertSeverity}>
                      {error}
                    </Alert>
                  )}
                  <Box display={"flex"} justifyContent={"space-evenly"}>
                    <Button onClick={submitNewMembers2} variant="contained">
                      ADD
                    </Button>
                    <Button onClick={cancelAddNewMembers2} variant="contained">
                      CANCEL
                    </Button>
                  </Box>
                </>
              )}
              <Box
                sx={{
                  display: "flex",
                  margin: "20px",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleDialogUsersClose}
                  color="customGray"
                >
                  CLOSE
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
            sx={{ marginTop: "20px" }}
          >
            <Button
              variant="contained"
              color="warning"
              startIcon={<SendIcon />}
              onClick={() => setSendEmailsDialogOpen(true)}
            >
              SEND EMAILS
            </Button>
            <Button
              variant="contained"
              color="info"
              startIcon={<NotificationsActiveIcon />}
              onClick={() => setSendRemindersDialogOpen(true)}
            >
              SEND REMINDERS
            </Button>
          </Box>
          <Typography variant="h6" sx={{ marginTop: "10px" }}>
            ADD REVIEWEE
          </Typography>
          {sendEmailsAlert && (
            <Alert
              sx={{ marginTop: "10px" }}
              severity={sendEmailsAlertSeverity}
              onClose={() => setSendEmailsAlert(false)}
            >
              {sendEmailsAlertMsg}
            </Alert>
          )}
          {sendRemindersAlert && (
            <Alert
              sx={{ marginTop: "10px" }}
              severity={sendRemindersAlertSeverity}
              onClose={() => setSendRemindersAlert(false)}
            >
              {sendRemindersAlertMsg}
            </Alert>
          )}
          <Divider sx={{ margin: "10px 0px" }} />
          <Box display={"flex"} justifyContent={"space-evenly"} gap={2}>
            {!showDropdown && (
              <Button onClick={showMemberSelect} variant="contained">
                ADD MEMBER
              </Button>
            )}
          </Box>
          <CsvUploadCombined360
            open={openCsvCombinedDialog}
            onClose={() => setOpenCsvCombinedDialog(false)}
            groupId={group._id}
            slug={slugAssessment}
            onSuccess={() => {
              updateTable();
              callGroups();
              // Only call user-specific functions if owner info is available
              if (ownerInfo?.ownerId && ownerInfo?.groupId) {
                callUsersEval(ownerInfo.ownerId, ownerInfo.groupId);
                callUsersListToAdd(ownerInfo.ownerId, ownerInfo.groupId);
              }
            }}
          />
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            onClick={() => setOpenCsvCombinedDialog(true)}
            sx={{ marginRight: "1rem" }}
          >
            BULK UPLOAD CSV (Reviewees & Reviewers)
          </Button>
          {showDropdown && (
            <>
              <Button
                onClick={() => setOpenDialogCreate(true)}
                startIcon={<AddCircleOutlineIcon />}
                variant="contained"
              >
                Add new reviewee
              </Button>
              <Autocomplete
                onChange={handleChange}
                options={selectOpt}
                renderInput={(params) => (
                  <TextField {...params} label="Search existing user" />
                )}
                sx={{ margin: "20px 0px" }}
              />
              <Dialog open={openDialogCreate} onClose={handleCloseDialogCreate}>
                <DialogContent>
                  <Typography variant="h5" color="primary">
                    CREATE REVIEWEE
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <Typography variant="subtitle1">First Name</Typography>
                      <TextField
                        onChange={handleChangeCreate}
                        value={firstName}
                        name="firstName"
                        fullWidth
                      />
                    </Grid>
                    <Grid size={6}>
                      <Typography variant="subtitle1">Last Name</Typography>
                      <TextField
                        onChange={handleChangeCreate}
                        value={lastName}
                        name="lastName"
                        fullWidth
                      />
                    </Grid>
                    <Grid size={6}>
                      <Typography variant="subtitle1">Email</Typography>
                      <TextField
                        onChange={handleChangeCreate}
                        value={email}
                        name="email"
                        fullWidth
                      />
                    </Grid>
                    {/* <Grid size={6}>
                                        <Typography variant="subtitle1">Type</Typography>
                                        <FormControl sx={{width:"100%"}}>
                                            <Select onChange={handleChangeCreate} value={type} name="type" fullWidth>
                                                <MenuItem value={"manager"}>Manager</MenuItem>
                                                <MenuItem value={"direct"}>Direct Report</MenuItem>
                                                <MenuItem value={"peer"}>Peer</MenuItem>
                                                <MenuItem value={"otherColleague"}>Other Colleague</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                    {showMsg2 && (
                      <Grid size={12}>
                        <Alert
                          sx={{ marginTop: "20px" }}
                          severity={msgSeverity2}
                        >
                          {msg2}
                        </Alert>
                      </Grid>
                    )}
                    <Grid
                      size={12}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button onClick={handleCreateUser} variant="contained">
                        CREATE
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleCloseDialogCreate}
                        sx={{ marginLeft: "20px" }}
                      >
                        CANCEL
                      </Button>
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>
            </>
          )}
          {usersList.length > 0 && (
            <>
              <Typography
                variant="subtitle1"
                fontWeight={500}
                color="secondary"
                sx={{ marginTop: "20px" }}
              >
                Reviewees to Add
              </Typography>
              <List>
                {usersList.map((u, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={`${u.firstName}${u.lastName ? ` ${u.lastName}` : ""}`}
                    />
                  </ListItem>
                ))}
              </List>
              {showError && (
                <Alert sx={{ marginTop: "20px" }} severity={alertSeverity}>
                  {error}
                </Alert>
              )}
              <Box display={"flex"} justifyContent={"space-evenly"}>
                <Button onClick={submitNewMembers} variant="contained">
                  ADD
                </Button>
                <Button onClick={cancelAddNewMembers} variant="contained">
                  CANCEL
                </Button>
              </Box>
            </>
          )}
          <Box
            sx={{ display: "flex", margin: "20px", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              onClick={handleDialogClose}
              color="customGray"
            >
              CLOSE
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Send Emails Confirmation Dialog */}
      <Dialog
        open={sendEmailsDialogOpen}
        onClose={() => !sendingEmails && setSendEmailsDialogOpen(false)}
      >
        <DialogTitle sx={{ color: "warning.main", fontWeight: "bold" }}>
          Send Launch Emails
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ marginBottom: "10px" }}>
            This will send emails to <strong>all reviewees and reviewers</strong>{" "}
            in this group.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • Each <strong>reviewee</strong> will receive a login link to
            complete their self-assessment.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "10px" }}>
            • Each <strong>reviewer</strong> will receive a direct link to
            submit their feedback.
          </Typography>
          <Typography variant="body2" color="error">
            Are you sure you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            onClick={() => setSendEmailsDialogOpen(false)}
            variant="contained"
            color="customGray"
            disabled={sendingEmails}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendLaunchEmails}
            variant="contained"
            color="warning"
            startIcon={
              sendingEmails ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <SendIcon />
              )
            }
            disabled={sendingEmails}
          >
            {sendingEmails ? "Sending..." : "Continue"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Send Reminders Confirmation Dialog */}
      <Dialog
        open={sendRemindersDialogOpen}
        onClose={() => !sendingReminders && setSendRemindersDialogOpen(false)}
      >
        <DialogTitle sx={{ color: "info.main", fontWeight: "bold" }}>
          Send Reminder Emails
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ marginBottom: "10px" }}>
            This will send reminder emails to{" "}
            <strong>reviewers who have not yet completed</strong> their
            assessment in this group.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            • Reviewers who have already completed their review will{" "}
            <strong>not</strong> be emailed.
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginBottom: "10px" }}
          >
            • Each incomplete reviewer will receive a friendly reminder with
            their direct link.
          </Typography>
          <Typography variant="body2" color="error">
            Are you sure you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            onClick={() => setSendRemindersDialogOpen(false)}
            variant="contained"
            color="customGray"
            disabled={sendingReminders}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendReminderEmails}
            variant="contained"
            color="info"
            startIcon={
              sendingReminders ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <NotificationsActiveIcon />
              )
            }
            disabled={sendingReminders}
          >
            {sendingReminders ? "Sending..." : "Continue"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Generate Report Confirmation Dialog */}
      <Dialog
        open={generateReportDialogOpen}
        onClose={() => !generatingReport && setGenerateReportDialogOpen(false)}
      >
        <DialogTitle sx={{ color: "success.main", fontWeight: "bold" }}>
          Generate Report
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ marginBottom: "10px" }}>
            This will generate the report and send a{" "}
            <strong>"Results Ready"</strong> email to{" "}
            <strong>all reviewers and the reviewee</strong>, even if they have
            not completed their assessment.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "10px" }}>
            • The reviewee will receive an email with a link to view their
            results.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "10px" }}>
            • All reviewers will be notified that the results are available.
          </Typography>
          <Typography variant="body2" color="error">
            Are you sure you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button
            onClick={() => setGenerateReportDialogOpen(false)}
            variant="contained"
            color="customGray"
            disabled={generatingReport}
          >
            Cancel
          </Button>
          <Button
            onClick={handleGenerateReport360}
            variant="contained"
            color="success"
            startIcon={
              generatingReport ? (
                <CircularProgress size={20} color="inherit" />
              ) : null
            }
            disabled={generatingReport}
          >
            {generatingReport ? "Generating..." : "Continue"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Send 360 Report Confirmation Dialog */}
      <Dialog open={openConfirmSend360} onClose={() => setOpenConfirmSend360(false)}>
        <DialogTitle>Send Report to Reviewee</DialogTitle>
        <DialogContent>
          <Typography>
            This will release the report to the reviewee and send them an email notification that their results are ready.
          </Typography>
          <Typography sx={{ marginTop: "10px", fontWeight: 600 }}>
            Are you sure you want to send the report?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmSend360(false)} color="inherit">
            CANCEL
          </Button>
          <Button onClick={handleSendReport360} variant="contained" color="primary">
            YES, SEND REPORT
          </Button>
        </DialogActions>
      </Dialog>

      <ViewResponsesDialog
        open={openSelfAssessment}
        onClose={() => setOpenSelfAssessment(false)}
        reviewerId={currentOwner}
        reviewerName="Reviewee (Self-Assessment)"
        ownerId={currentOwner}
        slug={slugAssessment}
      />

      {/* Type selection dialog for adding existing user as reviewer */}
      <Dialog open={typeDialogOpen} onClose={handleCancelReviewerType} maxWidth="xs" fullWidth>
        <DialogTitle>Assign Reviewer Type</DialogTitle>
        <DialogContent>
          {pendingReviewer && (
            <Typography sx={{ mb: 2 }}>
              Select a type for <strong>{pendingReviewer.firstName}{pendingReviewer.lastName ? ` ${pendingReviewer.lastName}` : ""}</strong>:
            </Typography>
          )}
          <FormControl fullWidth>
            <Select
              value={pendingReviewerType}
              onChange={(e) => setPendingReviewerType(e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>Select Type *</MenuItem>
              <MenuItem value="manager">Manager</MenuItem>
              <MenuItem value="direct">Direct Report</MenuItem>
              <MenuItem value="peer">Peer</MenuItem>
              <MenuItem value="otherColleague">Other Colleague</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReviewerType} color="inherit">CANCEL</Button>
          <Button
            onClick={handleConfirmReviewerType}
            variant="contained"
            color="primary"
            disabled={!["manager", "direct", "peer", "otherColleague"].includes(pendingReviewerType)}
          >
            ADD REVIEWER
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TeamsCards360;
